module.exports = __webpack_public_path__ + "static/img/cover2.8098a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cover2.png
// module id = yVCm
// module chunks = 18